import React, { useState } from 'react'
import GenericTableComponent from '../../../genericComponents/tableComponent/GenericTableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchHandler } from '../../../helper/apiHelperFunctions'
import GenericCustomButton from '../../../genericComponents/GenericCustomButton'
import { getPermissionKey } from '../../../helper/permissions'
import NewOnboardingRequestModal from './NewOnboardingRequestModal'
import ParentModal from '../../../genericComponents/ParentModal'
import GenericStatusComponent from '../../../genericComponents/GenericStatusComponent'
import { Plus } from 'lucide-react'

const RequestOnboardingComponent = (props) => {
	const dispatch = useDispatch();
	const generalStore = useSelector(state => state?.generalStore)
	const approveVendorOnboardingData = useSelector(state => state?.masterDbStore?.approveVendorOnboardingData)

	const [selectedModal, setSelectedModal] = useState("");

	const tableHeadersMap = {
		main: {
			name: "Main",
			key: "VENDOR_REQUESTED"
		}
	}

	const handleChange = (type, data) => {
		switch (type) {
			case "cancelVendorOnboarding": {
				dispatchHandler(dispatch, "approveVendorOnboardingRequest", {
					"ids": data?.map(item => item?.id),
					"status": "CANCELLED",
				}, getPermissionKey("masterData", "onboardingrequest", "approve"))
				break;
			}
		}
	}

	const renderRHSExtras = (selectedItems) => {
		return (
			<>
				<GenericCustomButton
					leftIcon={<Plus color="#ffffff" size={16} />}
					type='primary'
					label="Raise New Request"
					onClick={() => setSelectedModal('newOnboardingModal')}
				/>
				<GenericCustomButton
					sendEventAnalyticsToGoogle = {true}
					eventAnlyticsLabel = {"Cancel Vendor Onboarding Request"}
					disabled={generalStore?.getTableComponentListData?.isLoading || Object.keys(selectedItems).length === 0 || !Object.values(selectedItems).every(item => item?.status?.toUpperCase() === "PENDING")}
					type='reject'
					label="Cancel Request"
					onClick={() => handleChange("cancelVendorOnboarding", Object.values(selectedItems))}
				/>
			</>
		)
	}

	const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal(false) },
            animationType: "bottom",
        }
        switch (selectedModal) {
            case "newOnboardingModal": {
                return {
                    ...payload,
                    animationType: 'bottom',
                    // postitionProps: { top: "20%", left: "25%", position: "fixed", borderRadius: 4 },
                    // postitionProps: { top: "50%", left: "50%", position: "fixed", transform: 'translate(-50%, -50%)', borderRadius: 0 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
			        postitionProps: { position: 'relative' },
                    dimensions: { minWidth: "400px", maxWidth: '460px', height: 'fit-content', maxHeight: '90vh', overflowY: 'auto', borderRadius: 5 },
                    closeModal: () => setSelectedModal(""),
                    isOpen: selectedModal != '' ? true : false,
                    data: null
                }
            }
            default : 
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "newOnboardingModal": {
                return NewOnboardingRequestModal;
            }
            default : 
        }
    }

	return (
		<>
			<GenericTableComponent
				actionBarConfig={{
					isItemAvailable: true,
					rhsExtras: renderRHSExtras,
				}}
				tableConfig={{
					select: {
						disabled: false
					},
					customCols: {
						status: (item) => <GenericStatusComponent status={item?.["status"]} />
					}
				}}
				tableHeadersPayload={tableHeadersMap}
				tableHeadersMap={tableHeadersMap}
				tableDataPayload={{
					"pageNo": 1,
					"type": 1,
					pageSize: 10,
					"search": "",
					"filter": {},
					"sortedBy": "",
					"sortedIn": "",
					"status": "",
					"isActive": 1,
					"displayName": "VENDOR_REQUESTED",
					"apiUrl": "/core/enterprise/get/all/vendor/onboarding/request"
				}}
				tableData={{
					data: generalStore?.getTableComponentListData?.data?.resource?.data || [],
					totalItems: generalStore?.getTableComponentListData?.data?.resource?.totalCount || 0,
					currentPage: generalStore?.getTableComponentListData?.data?.resource?.currPage || 1,
					maxPage: generalStore?.getTableComponentListData?.data?.resource?.maxPage || 1,
					getTableApiData: generalStore?.getTableComponentListData?.resource?.data || []
				}}
				refreshData={approveVendorOnboardingData?.isSuccess}
				availableStores={["generalStore"]}
				{...props}
			/>
			{selectedModal ? <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            /> : null}
		</>
	)
}

export default RequestOnboardingComponent